module.exports = __webpack_public_path__ + "img/icon_map_51_off_110.256dbf2c.png";